import styled from "styled-components";
import {
  Card,
  CardContent,
  CardMedia,
  Type,
  VideoPlayerPoster,
} from "@ebscois/react-component-library";

const MediaCard = styled(Card)`
  margin: ${({ theme }) => theme.space.md} 0;
  @media print {
    display: block;
  }
`;

const MediaContent = styled(CardContent)`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  @media print {
    display: none;
  }
`;

const Media = styled(CardMedia)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex: none;
    width: 10rem;
  }

  cursor: ${({ isMediaClickDisabled }) =>
      isMediaClickDisabled ? "default" : "pointer"}
    ${({ $hideInlineVideoPrint }) =>
      $hideInlineVideoPrint &&
      `@media print {
      display: none !important;
    }`};
`;

const MediaImage = styled.img`
  max-height: 10rem;
  max-width: 100%;
  @media print {
    max-height: 15rem;
  }
`;

const MediaDescription = styled(Type)`
  &&:not(:first-child) {
    margin-top: 0.25rem;
  }
`;

const MediaTitle = styled(Type)`
  &&:not(:last-child) {
    margin-bottom: 0;
  }
`;

const StyledVideoPlayerPoster = styled(VideoPlayerPoster)``;

const MediaCopyright = styled(Type)`
  ${({ theme }) => `
    font-family: ${theme.font.family.base};
    color: ${theme.colors.gray800};
    font-size: ${theme.font.size.xs};
    font-weight: ${theme.font.weight.normal};
  `};

  line-height: 1.5;
`;

const PdfButton = styled.button`
  float: right;
  background: transparent;
  padding: 0.6875rem;
  border-width: 0.0625rem;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.anchor};
  border-radius: 3px;
  display: inline-flex;
  cursor: pointer;
  &:hover {
    background: #d4e3ea;
  }
`;

const MediaHeader = styled.div`
  max-width: 1440px;
  place-content: center space-between;
  align-items: flex-start;
  -webkit-box-pack: justify;
  display: flex;
  width: 100%;
`;

export {
  MediaCard,
  MediaContent,
  Media,
  MediaImage,
  MediaTitle,
  MediaHeader,
  MediaDescription,
  StyledVideoPlayerPoster,
  MediaCopyright,
  PdfButton,
};
